import { useState, useEffect } from 'react';

export function useQuery<T>(
	fn: () => Promise<T>,
	key?: string | number,
	fetchOnlyIf = true,
) {
	const [loading, setLoading] = useState(fetchOnlyIf);
	const [error, setError] = useState<Error | null>(null);
	const [data, setData] = useState<T | null>(null);

	useEffect(() => {
		if (fetchOnlyIf && !key) {
			fn()
				.then((data) => {
					setData(data);
				})
				.catch((err) => {
					setError(err);
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, []);

	useEffect(() => {
		if (key && fetchOnlyIf) {
      setLoading(true)
			refetch();
		}
	}, [key, fetchOnlyIf]);

	function refetch() {
		fn()
			.then((data) => {
				setData(data);
			})
			.catch((err) => {
				setError(err);
			}).finally(() => {
        setLoading(false)
      });
	}

	return { loading, data, setData, error, refetch };
}
